import { AppBar, Toolbar } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../../assets/img/Logo';

const UnauthorizedNavbar = (props) => (
  <AppBar
    elevation={0}
    {...props}
  >
    <Toolbar sx={{ height: 64 }}>
      <RouterLink to="/">
        <Logo width={130}/>
      </RouterLink>
    </Toolbar>
  </AppBar>
);

export default UnauthorizedNavbar;
